import React from 'react';
import { Phone, FileText } from 'lucide-react';
export function MobileStickyCTA() {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 p-3 shadow-[0_-4px_10px_rgba(0,0,0,0.05)] z-50 flex gap-3" data-id="element-637">
      <a href="tel:5175457772" className="flex-1 bg-slate-100 hover:bg-slate-200 text-navy-900 font-semibold py-3 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors text-sm" data-id="element-638">
        <Phone className="w-4 h-4" data-id="element-639" />
        Call
      </a>
      <a href="#quote-form" className="flex-[2] bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors text-sm" data-id="element-640">
        <FileText className="w-4 h-4" data-id="element-641" />
        Request Estimate
      </a>
    </div>;
}